import { Card } from "@/components/ui/card";

export const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-gradient-secondary">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">About queueOS</h2>
          <p className="text-xl text-muted-foreground mb-8">
            queueOS helps teams manage tasks and customer requests with a beautiful, efficient workflow. Built for clarity and speed.
          </p>
        </div>
        <div className="max-w-5xl mx-auto">
          <Card className="p-8 bg-card/60 border-border/60 backdrop-blur-sm">
            <p className="text-muted-foreground leading-relaxed">
              Designed with modern teams in mind, queueOS brings together smart queues, real-time collaboration, and customizable forms—
              all powered by a clean, accessible interface that adapts to your workspace.
            </p>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
